import { defineComponent } from 'vue';
import { deleteProcessor, getProcessorsByUser } from '@/api/dataentry-api-generated';
import ProcessorDialog from '@/components/ProcessorDialog.vue';
import ProcessorDuplicateDialog from '@/components/ProcessorDuplicateDialog.vue';
import DeleteDialog from '@/components/DeleteDialog.vue';
export default defineComponent({
    name: 'Processors',
    components: { ProcessorDialog, DeleteDialog, ProcessorDuplicateDialog },
    data() {
        return {
            loading: false,
            items: [],
            filter: '',
            selected: [],
            columns: [
                {
                    name: 'action',
                    label: 'EDIT',
                    align: 'center'
                },
                {
                    name: 'duplicate',
                    label: 'Duplicate',
                    align: 'center'
                },
                {
                    field: 'processorId',
                    name: 'processorId',
                    label: 'Processor ID',
                    sortable: true,
                    align: 'center'
                },
                {
                    field: 'companyName',
                    name: 'companyName',
                    label: 'Company Name',
                    sortable: true,
                    align: 'center'
                },
                {
                    field: 'site',
                    name: 'site',
                    label: 'Site Name',
                    sortable: true,
                    align: 'center'
                },
                {
                    field: 'abattoirAddress',
                    name: 'abattoirAddress',
                    label: 'Abattoir Address',
                    sortable: true,
                    align: 'center'
                },
                {
                    field: 'abattoirState',
                    name: 'abattoirState',
                    label: 'Abattoir State',
                    sortable: true,
                    align: 'center'
                },
                {
                    field: 'abattoirPostcode',
                    name: 'abattoirPostcode',
                    label: 'Abattoir Postcode',
                    sortable: true,
                    align: 'center'
                },
                {
                    field: 'speciesList',
                    name: 'speciesList',
                    label: 'Species',
                    sortable: true,
                    align: 'center',
                    format: (val) => val.join(', ')
                },
                {
                    field: 'yearEntry',
                    name: 'yearEntry',
                    label: 'Year',
                    sortable: true,
                    align: 'center',
                    format: (val) => val || '-'
                },
                {
                    field: 'integratedFeedlot',
                    name: 'integratedFeedlot',
                    label: 'Integrated Feedlot',
                    sortable: false,
                    align: 'center',
                    format: (val) => val === true ? 'Yes' : 'No' || '-'
                },
                {
                    field: 'slaughter',
                    name: 'slaughter',
                    label: 'Slaughter',
                    sortable: false,
                    align: 'center',
                    format: (val) => val === true ? 'Yes' : 'No' || '-'
                },
                {
                    field: 'boning',
                    name: 'boning',
                    label: 'Boning',
                    sortable: false,
                    align: 'center',
                    format: (val) => val === true ? 'Yes' : 'No' || '-'
                },
                {
                    field: 'chiller',
                    name: 'chiller',
                    label: 'Chiller',
                    sortable: false,
                    align: 'center',
                    format: (val) => val === true ? 'Yes' : 'No' || '-'
                },
                {
                    field: 'hideProcessing',
                    name: 'hideProcessing',
                    label: 'Hide Processing',
                    sortable: false,
                    align: 'center',
                    format: (val) => val === true ? 'Yes' : 'No' || '-'
                },
                {
                    field: 'rendering',
                    name: 'rendering',
                    label: 'Rendering',
                    sortable: false,
                    align: 'center',
                    format: (val) => val === true ? 'Yes' : 'No' || '-'
                },
                {
                    field: 'renderProductFromOffsite',
                    name: 'renderProductFromOffsite',
                    label: 'Render Product From Offsite',
                    sortable: false,
                    align: 'center',
                    format: (val) => val === true ? 'Yes' : 'No' || '-'
                },
                {
                    field: 'valueAdding',
                    name: 'valueAdding',
                    label: 'Value Adding',
                    sortable: false,
                    align: 'center',
                    format: (val) => val === true ? 'Yes' : 'No' || '-'
                },
                {
                    field: 'packing',
                    name: 'packing',
                    label: 'Packing',
                    sortable: false,
                    align: 'center',
                    format: (val) => val === true ? 'Yes' : 'No' || '-'
                },
                {
                    field: 'mainComputerOperatingSystems',
                    name: 'mainComputerOperatingSystems',
                    label: 'Main Computer Operating Systems',
                    sortable: true,
                    align: 'center'
                }
            ],
            tablePagination: {
                rowsPerPage: 50,
                rowsNumber: 0,
                sortBy: 'processorId',
                descending: false,
                page: 1
            }
        };
    },
    mounted() {
        this.refresh();
    },
    computed: {
        storeTablePagination() {
            return this.$store.getters.processorsPagination;
        },
        deleteDialogTitle() {
            const length = this.selected.length;
            const item = length > 1 ? 'Processors' : 'Processor';
            return `Delete ${length} ${item}`;
        },
        deleteDialogMsg() {
            const length = this.selected.length;
            const record = length > 1 ? 'these records' : 'this record';
            return `Are you sure you want to delete ${record}?`;
        }
    },
    watch: {
        storeTablePagination(newPagination) {
            this.tablePagination.rowsNumber = newPagination.rowsNumber;
            this.tablePagination.rowsPerPage = newPagination.rowsPerPage;
            this.tablePagination.page = newPagination.page;
        }
    },
    methods: {
        refresh() {
            this.fetch({
                pagination: {
                    page: 1,
                    rowsNumber: this.tablePagination.rowsNumber,
                    sortBy: this.tablePagination.sortBy,
                    descending: this.tablePagination.descending,
                    rowsPerPage: this.tablePagination.rowsPerPage
                }
            });
        },
        async getItems(filter, pageNumber, pageSize, orderByField, orderByAscending) {
            this.loading = true;
            try {
                const result = await getProcessorsByUser({ pageNumber: pageNumber, pageSize: pageSize, orderByField: orderByField, orderByAscending: orderByAscending, deleted: false });
                this.items = this.filterResults(result.items, filter);
                const newPagination = {
                    pageNumber: result.pageNumber,
                    totalNumberOfRecords: result.totalNumberOfRecords
                };
                this.setPagination(newPagination);
                this.loading = false;
            }
            catch (error) {
                this.$log.addError(error);
                this.loading = false;
            }
        },
        edit(uuid) {
            this.$router.push({ name: 'Processor', params: { uuid: uuid } });
        },
        async deleteItems() {
            await Promise.all(this.selected.map(async (i) => {
                try {
                    await deleteProcessor(i.uuid);
                    this.$log.addMessage('Successfully deleted Processor');
                }
                catch (error) {
                    this.$log.addError(error);
                }
            }));
            this.selected = [];
            this.refresh();
        },
        fetch(props) {
            let { page, rowsPerPage, sortBy, descending } = props.pagination;
            // update local pagination object
            this.tablePagination.page = page;
            this.tablePagination.rowsPerPage = rowsPerPage;
            this.tablePagination.sortBy = sortBy;
            this.tablePagination.descending = descending;
            // if sortBy is null, set to undefined - user has cleared the sort column
            sortBy = sortBy === null ? undefined : sortBy;
            this.getItems(this.filter, page, rowsPerPage, sortBy, !descending);
        },
        setPagination(newPagination) {
            this.tablePagination.page = newPagination.pageNumber;
            this.tablePagination.rowsNumber = newPagination.totalNumberOfRecords;
        },
        filterResults(results, filter) {
            if (filter !== undefined && filter.length > 0) {
                filter = filter ? filter.trim().toLowerCase() : filter;
                const filteredResults = results.filter((x) => {
                    let found = false;
                    // Search each individual 'value' in the object for the specified 'filter'
                    Object.keys(x).forEach(key => {
                        if (typeof x[key] === 'string') {
                            if (x[key].toLowerCase().includes(filter)) {
                                found = true;
                                // found something, stop searching
                            }
                        }
                        else if (typeof x[key] === 'number') {
                            if (x[key].toString().includes(filter)) {
                                found = true;
                                // found something
                            }
                        }
                    });
                    return found;
                });
                return filteredResults;
            }
            else {
                return results;
            }
        }
    }
});
